import React from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Svg } from "assets";

export const AccordionSimple = ({ list, handleChange, expanded }) => {
  const toggleAccordion = (index, item) => {
    handleChange && handleChange(item, index);
  };

  return (
    list?.length > 0 && (
      <div className="accordion-simple-wrapper">
        {list
          ?.filter((item) => item)
          ?.map((item, index) => (
            <Accordion
              className="accordion-simple-box"
              key={index}
              expanded={expanded === item?.value}
              disabled={item?.disabled}
            >
              {item?.accordionSummary && (
                <AccordionSummary
                  expandIcon={<Svg.ArrowDown />}
                  onClick={() => toggleAccordion(index + 1, item)}
                  className={`accordion-simple-summary-wrapper ${
                    !item?.accordionDetails
                      ? "accordion-radio-summary-no-expanded"
                      : ""
                  }`}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  {item?.accordionSummary}
                </AccordionSummary>
              )}

              {item?.accordionDetails && (
                <AccordionDetails className="accordion-radio-details-wrapper">
                  {item?.accordionDetails}
                </AccordionDetails>
              )}
            </Accordion>
          ))}
      </div>
    )
  );
};
